var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3314 21.34C11.2414 21.34 10.1514 20.93 9.32144 20.1C7.66144 18.44 7.66144 15.75 9.32144 14.09L11.8014 11.62C12.0914 11.33 12.5714 11.33 12.8614 11.62C13.1514 11.91 13.1514 12.39 12.8614 12.68L10.3814 15.15C9.31144 16.22 9.31144 17.97 10.3814 19.04C11.4514 20.11 13.2014 20.11 14.2714 19.04L18.1614 15.15C19.3414 13.97 19.9914 12.4 19.9914 10.73C19.9914 9.05998 19.3414 7.48998 18.1614 6.30999C15.7214 3.86999 11.7614 3.86999 9.32144 6.30999L5.08144 10.55C4.09144 11.54 3.54144 12.86 3.54144 14.26C3.54144 15.66 4.09144 16.98 5.08144 17.97C5.37144 18.26 5.37144 18.74 5.08144 19.03C4.79144 19.32 4.31144 19.32 4.02144 19.03C2.75144 17.75 2.04144 16.06 2.04144 14.26C2.04144 12.46 2.74144 10.76 4.02144 9.48998L8.26144 5.24999C11.2814 2.22999 16.2014 2.22999 19.2214 5.24999C20.6814 6.70999 21.4914 8.65998 21.4914 10.73C21.4914 12.8 20.6814 14.75 19.2214 16.21L15.3314 20.1C14.5014 20.93 13.4214 21.34 12.3314 21.34Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.c6e8bfa2b75e7f5ffb4841d6704bcfde.svg";
export { ForwardRef as ReactComponent };